//React component
import React from 'react'
import { useTranslation } from 'react-i18next'

//app component
import { AppLayout } from '../../layouts'
import { useTheme } from '../../contexts/ThemeContext'
import { getTenantLogo } from '../../constants/Images'
import { getTenantName } from '../../utils/brandingStyles'


const CheckMailBox = () => {
    const { t } = useTranslation()
    const { theme } = useTheme()
    const textClass = theme === 'light' ? 'text-dark' : 'text-white'

    return (
        <AppLayout>
            <div className="container p-5 text-center d-flex align-items-center justify-content-center min-vh-100">

                <div className="pb-5">
                    <span>
                        <i className={`fa-regular fa-envelope my-5 ${textClass}`} style={{ fontSize: 90 }} aria-hidden />
                    </span>
                    <div>
                        <img className='img-fluid' src={getTenantLogo(theme)} alt={getTenantName()} style={{ width: 100 }} />
                        <div className='mt-3'>
                            <p className={`mb-4 fs-6 ${textClass}`}>{t('views.auth.mailVerification')} <br />{t('views.auth.pleaseFollowTheInstructions')} </p>
                        </div>

                    </div>
                </div>

            </div>
        </AppLayout>
    )
}

export default CheckMailBox 